import type { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';
import MuiTypography from '@mui/material/Typography';

import { responsiveFontSizes } from './fontSizes';

interface TextProps extends Omit<MuiTypographyProps, 'size'> {
  size?: keyof typeof responsiveFontSizes; // 32, 24, etc.
}

const Text = ({ size = 16, sx, ...rest }: TextProps) => {
  return (
    <MuiTypography
      sx={{ fontSize: responsiveFontSizes[size], ...sx }}
      {...rest}
    />
  );
};

export default Text;
